(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vf-urg"] && !Shopify.designMode) return;
  try {
    class VfUrgencia extends HTMLElement {
    connectedCallback() {
      this.cd = this.querySelector('.vf-urg__countdown');
      if (this.cd) this.initCountdown();
      this.notes = Array.from(this.querySelectorAll('[data-note]'));
      if (this.notes.length > 1) this.initRotation();
    }
    pad(n) { return String(n).padStart(2, '0'); }
    initCountdown() {
      this.evergreen = (this.cd.getAttribute('data-mode') || 'fixed') === 'evergreen';
      if (this.evergreen) {
        const mins = parseInt(this.cd.getAttribute('data-duration'), 10) || 180;
        this.dur = mins * 60000;
        const KEY = 'vf-urg-evergreen';
        let stored = parseInt(localStorage.getItem(KEY), 10);
        const now = Date.now();
        if (!stored || isNaN(stored) || stored <= now) {
          stored = now + this.dur;
          try { localStorage.setItem(KEY, stored); } catch (e) {}
        }
        this.end = stored;
      } else {
        const raw = (this.cd.getAttribute('data-end') || '').trim().replace(' ', 'T');
        this.end = raw ? new Date(raw).getTime() : NaN;
      }
      this.boxesEl = this.cd.querySelector('.vf-urg__cd-boxes');
      this.expiredEl = this.cd.querySelector('.vf-urg__expired');
      this.daysWrap = this.cd.querySelector('[data-days-wrap]');
      this.elDays = this.cd.querySelector('[data-days]');
      this.elHours = this.cd.querySelector('[data-hours]');
      this.elMins = this.cd.querySelector('[data-mins]');
      this.elSecs = this.cd.querySelector('[data-secs]');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      if (isNaN(this.end)) return;
      let diff = this.end - Date.now();
      if (diff <= 0) {
        if (this.evergreen) {
          this.end = Date.now() + this.dur;
          try { localStorage.setItem('vf-urg-evergreen', this.end); } catch (e) {}
          diff = this.dur;
        } else {
          clearInterval(this.timer);
          if (this.boxesEl) this.boxesEl.hidden = true;
          if (this.expiredEl) this.expiredEl.hidden = false;
          return;
        }
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (this.daysWrap) this.daysWrap.hidden = d <= 0;
      if (this.elDays) this.elDays.textContent = this.pad(d);
      this.elHours.textContent = this.pad(h);
      this.elMins.textContent = this.pad(m);
      this.elSecs.textContent = this.pad(s);
    }
    initRotation() {
      const speed = parseInt(this.getAttribute('data-rotate'), 10) || 4000;
      let i = 0;
      this.rot = setInterval(() => {
        this.notes[i].classList.remove('is-active');
        i = (i + 1) % this.notes.length;
        this.notes[i].classList.add('is-active');
      }, speed);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearInterval(this.rot);
    }
  }
  if (!customElements.get('vf-urgencia')) {
    customElements.define('vf-urgencia', VfUrgencia);
  }
  } catch(e) { console.error(e); }
})();

})();
